var render = function render(){var _vm=this,_c=_vm._self._c;return _c('network-list',{attrs:{"hidden-actions":['create'],"hidden-columns":['brand', 'region', 'account', 'tenant'],"hidden-filter-options":['vpc'],"id":_vm.id,"getParams":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }